// extracted by mini-css-extract-plugin
module.exports = {"ArticleMedia":"ArticleMedia_ArticleMedia__EC2JQ","ArticleMedia_caption":"ArticleMedia_ArticleMedia_caption___LZHI"};